module.exports = __webpack_public_path__ + "img/202407_08.d267eb1a.jpg";